import "./NotificationsWebPage.css";
import useNotifications from "./useNotifications";
import { getTranslatedText as translate } from "../Localization/Translation";
import Footer from "../Footer/Footer.js";
import RatingStars from "./RatingStars";

const NotificationsWebPage = () => {
  const { locale, notifications, NotificationsStatusesAndText } =
    useNotifications();

  let d = "-1";
  var NotificationCards = notifications.map((notification, keyIndex) => {
    d = Number(d) + 1;

    var BackgroundNotificationColor = "card-body";
    if (notification.new)
      BackgroundNotificationColor = "card-body card-body-blue-notification";
    return (
      <div
        className={
          "Laund-item-list card-item-list col animate__animated animate__fadeInDown animate__delay-" +
          d +
          "s"
        }
        key={notification.id}
      >
        <div className=" Laund-item-card-list notification-item-card-list">
          <div className="card card-body-notification">
            <div className={BackgroundNotificationColor}>
              <div className="d-flex justify-content-between align-items-center">
                {/* Name of order */}
                <div
                  className="card-title-notification"
                  style={{ width: "100%" }}
                >
                  {keyIndex === 6 || keyIndex === 7 ? (
                    <>
                      <h5 className="card-title card-title-notification">
                        {translate("Laundry-name-label-order", locale)}
                        {notification.LaundryName}
                      </h5>
                      <h6 className="card-title">{notification.date}</h6>
                    </>
                  ) : (
                    <>
                      <h5 className="card-title card-title-notification">
                        {translate("order-num-notification", locale)}
                        {notification.orderNumber}
                      </h5>
                      <h6 className="card-title">{notification.date}</h6>
                    </>
                  )}
                </div>
              </div>

              <hr />

              {/* Text of Notification */}

              {NotificationsStatusesAndText.map((StatusAndText, keystate) => {
                if (StatusAndText.status === notification.status) {
                  if (keystate === 2) {
                    return (
                      <div
                        className="card-text card-text-notification"
                        key={keystate}
                      >
                        <p>
                          {NotificationsStatusesAndText[2].text}(
                          <span style={{ fontWeight: "bold" }}>
                            اسم المندوب
                          </span>
                          )
                        </p>
                      </div>
                    );
                  }
                  // else if (keystate === 4) {
                  //   return (
                  //     <div
                  //       className="card-text card-text-notification"
                  //       key={keystate}
                  //     >
                  //       <p>{NotificationsStatusesAndText[4].text}</p>
                  //       <DetailsTable done={false} />
                  //     </div>
                  //   );
                  // }
                  else if (keystate === 5) {
                    return (
                      <div
                        key={keystate}
                        className="card-text card-text-notification"
                      >
                        <p className="delivered-text-notification">
                          {StatusAndText.text}
                          <i className="bi bi-check-circle-fill"></i>
                        </p>
                        <hr />
                        <div className="rate-us-notification">
                          <span className="rate-notification-label">
                            {translate("rate-send-notification", locale)}
                          </span>
                          <RatingStars />
                        </div>
                        <hr />
                        <div className="send-note-notification row">
                          <span className="mb-3 note-notification-label col-md-5">
                            {translate("note-send-notification", locale)}
                          </span>
                          <div className="col-md row gap-3">
                            <input
                              type="text"
                              className="form-control col-md"
                            />
                            <button className="btn btn-primary col-md">
                              {translate("send-btn", locale)}
                            </button>
                          </div>
                        </div>
                      </div>
                    );
                  } else
                    return (
                      <p
                        key={keystate}
                        className="card-text card-text-notification"
                      >
                        {StatusAndText.text}
                      </p>
                    );
                } else {
                  return <span key={keystate}></span>;
                }
              })}
            </div>
          </div>
        </div>
      </div>
    );
  });

  return (
    <div className="notifications-web-page">
      <div className="notifications-component">
        <div className="main-component notifications-section">
          {NotificationCards}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NotificationsWebPage;
